export const LEGAL_LAST_UPDATED = '2026-04-05';

export const TERMS_OF_SERVICE_CONTENT = `TERMS OF SERVICE FOR UNLOCK APP

Last Updated: ${LEGAL_LAST_UPDATED}

1. ACCEPTANCE OF TERMS
By creating an account or using the Unlock App ("Service"), you agree to be bound by these Terms of Service ("Terms").

2. ELIGIBILITY
You must be at least 18 years old to use this Service.

3. SERVICE DESCRIPTION
Unlock App allows users ("Fans") to pay for 24-hour chat access with other users ("Celebrities").

4. PAYMENTS AND REFUNDS
- All payments are processed in Egyptian Pounds (EGP).
- Payments are non-refundable once processed.
- The Service charges a 13% platform fee on all transactions.
- Payment verification may take up to 24 hours.

5. CHAT TERMS
- Celebrities are not obligated to reply to messages from Fans.
- Purchasing chat access grants you a 24-hour window to send messages.
- All chat participants must maintain respectful communication.

6. USER CONDUCT
You agree to use the Service lawfully and respectfully.

7. LIMITATION OF LIABILITY
To the maximum extent permitted by Egyptian law, Unlock App shall not be liable for any direct, indirect, incidental, special, or consequential damages.

8. INDEMNIFICATION
You agree to indemnify and hold harmless Unlock App from any claims arising from your use of the Service.

9. TERMINATION
We reserve the right to terminate or suspend your account at any time for violations.

10. GOVERNING LAW
These Terms are governed by the laws of the Arab Republic of Egypt.

11. CHANGES TO TERMS
We reserve the right to modify these Terms at any time.

12. CONTACT INFORMATION
For questions about these Terms, contact: support@unlockapp.me`;

export const PRIVACY_POLICY_CONTENT = `PRIVACY POLICY FOR UNLOCK APP

Last Updated: ${LEGAL_LAST_UPDATED}

1. INFORMATION WE COLLECT
- Personal information: username, email, gender.
- Profile information: profile picture, chat preferences.
- Payment information: payment method details, payment amounts.
- Chat data: messages sent and received.
- Technical data: device information and usage statistics.

2. HOW WE USE YOUR INFORMATION
We use your information to provide and maintain the Service, process payments, verify transactions, and improve the Service.

3. DATA SHARING AND DISCLOSURE
We do not sell your personal data. We may share information with other users as necessary for the Service.

4. DATA RETENTION
We retain your data for as long as your account is active or as needed to provide the Service.

5. DATA SECURITY
We implement appropriate measures to protect your personal data.

6. YOUR RIGHTS
Under Egyptian Law No. 151 of 2020, you have the right to access, correct, and request deletion of your data.

7. CHILDREN'S PRIVACY
The Service is not intended for users under 18 years of age.

8. CHANGES TO PRIVACY POLICY
We may update this Privacy Policy periodically.

9. CONTACT INFORMATION
For privacy-related inquiries, contact: support@unlockapp.me`;
